import React, { ReactNode } from 'react';
import classNames from 'classnames';
import DragIcon from 'icons/Drag.icon';
import { CollapsibleSection } from 'components/CollapsibleSection';
import utils from 'utils';
import { XOR } from 'types';
import { Button } from 'ncoded-component-library';
import usePress from 'hooks/usePress';
import useMatchMedia from 'hooks/useMatchMedia';

import './QuestionCollapsible.styles.scss';
import './QuestionCollapsible.styles.responsive.scss';

type CollapsibleInnerStateControlled = {
  defaultOpen?: boolean;
};

type CollapsibleParentControlled = {
  open: boolean;
};

type QuestionCollapsibleProps = {
  className?: string;
  disabled?: boolean;
  trigger?: ReactNode;
  setIsReordering?: React.Dispatch<React.SetStateAction<boolean>>;
} & XOR<CollapsibleInnerStateControlled, CollapsibleParentControlled>;

const QuestionCollapsible: React.FC<QuestionCollapsibleProps> = (props) => {
  const {
    children,
    className,
    trigger,
    open,
    defaultOpen,
    disabled = false,
    setIsReordering,
  } = props;

  const classes = classNames('question-collapsible', { disabled }, className);

  const events = usePress({
    onPressStart: () => setIsReordering(true),
    onPressEnd: () => setIsReordering(false),
  });

  const isPhablet = useMatchMedia('isPhablet');

  return (
    <div className={classes}>
      {!isPhablet && (
        <div className="question-collapsible__left">
          <Button
            icon={DragIcon}
            variant="icon"
            disabled={disabled}
            {...(!disabled && events)}
          />
        </div>
      )}

      <div className="question-collapsible__right">
        {open ? (
          <CollapsibleSection
            open
            onAnimationEnd={utils.noop}
            trigger={trigger}
          >
            {children}
          </CollapsibleSection>
        ) : (
          <CollapsibleSection defaultOpen={defaultOpen} trigger={trigger}>
            {children}
          </CollapsibleSection>
        )}
      </div>
    </div>
  );
};

export default QuestionCollapsible;
